import { MessageDescriptor } from 'react-intl';

import {
  GetTemplateListEmptyMessageParams,
  templateListMessages,
} from '../config';

export const getTemplateListEmptyMessage = ({
  hasActiveFilters,
  hasSelectedSpecialty,
  hasSpecialtyTemplates,
  isSelectedSpecialtyHiddenByFilter,
  isSelectedSpecialtyUnavailable,
}: GetTemplateListEmptyMessageParams): MessageDescriptor => {
  if (isSelectedSpecialtyHiddenByFilter) {
    return templateListMessages.noTemplatesForFilters;
  }

  if (isSelectedSpecialtyUnavailable) {
    return templateListMessages.selectedSpecialtyUnavailable;
  }

  if (hasSelectedSpecialty && !hasSpecialtyTemplates) {
    return templateListMessages.noTemplatesInSchema;
  }

  if (hasActiveFilters) {
    return templateListMessages.noTemplatesForFilters;
  }

  return templateListMessages.noTemplates;
};
